/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.INT = function () {

    this.resourceKey = 'Survey.Sidebar.Integer';
    // server side is expecting INT and our field is INTEGER
    this.jsonType = 'INT';
    this.fieldType = 'INTEGER';

    Greenmile.Survey.Sidebar.Generic.apply(this, arguments);
};